import React, { useEffect, useMemo, useState } from "react";
import DropdownField from "../../../../common/components/FormFields/DropdownField";
import DatePickerField from "../../../../common/components/FormFields/DatePickerField";
import LoadingSpinner from "../../../../common/components/loadingspinner/loadingSpinner";
import CommonTransactionPaginationTable from "../../../../common/components/CommonTable/CommonTransactionPaginationTable";
import { useForm } from "react-hook-form";
import { parse, format, addMinutes, differenceInMinutes } from "date-fns";
import CommonButton from "../../../../common/components/Buttons/CommonButton";
import { fetchKitWiseCycleDetailsList } from "../../../services/cssdCycleDetailsServices/CssdCycleDetailsServices";

const UserAction = [
  {
    id: 1,
    permission: "Create",
    isAction: false,
    menuId: null,
    functionalityId: null,
    menuKey: null,
  },
  {
    id: 3,
    permission: "Cancel",
    isAction: true,
    menuId: null,
    functionalityId: null,
    menuKey: null,
  },
  {
    id: 4,
    permission: "Print",
    isAction: true,
    menuId: null,
    functionalityId: null,
    menuKey: null,
  },
  {
    id: 4,
    permission: "CheckOut",
    isAction: true,
    menuId: null,
    functionalityId: null,
    menuKey: null,
  },
];

function CSSDKit() {
  const defaultValues = {
    kit: null,
    fromdate: null,
    toDate: null,
  };
  const { control, watch, setValue, register, reset } = useForm({
    mode: "onChange",
    defaultValues,
  });

  const [userAction, setUserAction] = useState(UserAction);
  const [dataResult, setDataResult] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [count, setCount] = useState(null);
  const [isShowSpinner, setIsShowSpinner] = useState(false);
  const [searchString, setSearchString] = useState(null);
  const [selectedKit, setSelectedKit] = useState(null);
  const [listingObject, setListingObject] = useState({
    kitId: null,
    fromDate: null,
    toDate: null,
  });

  let getFromDate = watch("fromdate");
  let getToDate = watch("toDate");
  let getKit = watch("kit");

  const populateTable = (forPagination) => {
    let listObj = {
      fromDate: getFromDate,
      toDate: getToDate,
      kitId: getKit ? getKit?.id : null,
      page: page,
      size: rowsPerPage,
    };
    fetchKitWiseCycleDetailsList(listObj).then((response) => {
      if (forPagination) {
        setDataResult((prevData) => [
          ...prevData,
          JSON.parse(...response?.data?.result)?.map((val) => ({
            "Sr. No.": val?.["Sr. No."],
            "Kit Batch No": val?.["Kit Batch No"],
            "Cycle No": val?.["Cycle No"],
            "Start Time": val?.["Start Time"],
            "End Time": val?.["End Time"],
            "Sterilization Method": val?.["Sterilization Method"],
            "Temp. (°C)": val?.["Temp. (°C)"],
            Pressure: val?.Pressure,
            Status: val?.Status,
            "Kit Cycle Time": val?.["Kit Cycle Time"],
            ...val,
          })),
        ]);
      } else {
        setDataResult(
          JSON.parse(response?.data?.result)?.map((val) => ({
            "Sr. No.": val?.["Sr. No."],
            "Kit Batch No": val?.["Kit Batch No"],
            "Cycle No": val?.["Cycle No"],
            "Start Time": val?.["Start Time"],
            "End Time": val?.["End Time"],
            "Sterilization Method": val?.["Sterilization Method"],
            "Temp. (°C)": val?.["Temp. (°C)"],
            Pressure: val?.Pressure,
            Status: val?.Status,
            "Kit Cycle Time": val?.["Kit Cycle Time"],
            ...val,
          }))
        );
      }
      setCount(response.data.count);
    });
  };

  const handleSelectedRow = (row, index) => {
    setSelectedKit(row);
  };

  const rowBackgroundColor = (row, index) => {
    if (selectedKit === null && index === 0) {
      return "#FFC44B";
    }
  };

  const renderInput = (row, index, header) => {
    return (
      <>
        {header === "Status" && (
          <button
            className={`h-6 w-24 whitespace-nowrap border rounded capitalize px-5 text-center
                     ${row?.Status === "Success"
                ? "text-[#3FC28A] bg-[#ECF9F3] border-[#3FC28A]"
                : "text-[#EF1212] bg-[#EF12121A] border-[#EF1212]"
              }`}
            type="button"
          >
            {row?.Status}
          </button>
        )}
      </>
    );
  };

  const DATE_FORMAT = "dd/MM/yyyy, hh:mm a";

  const generateTimeline = (
    startTimeStr,
    endTimeStr,
    receiveTimeStr,
    cleaningTimeStr,
    WrappingTimeStr,
    SterilizeTimeStr
  ) => {
    try {
      const startTime = parse(startTimeStr, DATE_FORMAT, new Date());
      const endTime = parse(endTimeStr, DATE_FORMAT, new Date());
      const receiveTime = parse(receiveTimeStr, DATE_FORMAT, new Date());
      const cleaningTime = parse(cleaningTimeStr, DATE_FORMAT, new Date());
      const wrappingTime = parse(WrappingTimeStr, DATE_FORMAT, new Date());
      const sterilizeTime = parse(SterilizeTimeStr, DATE_FORMAT, new Date());

      if (isNaN(startTime) || isNaN(endTime)) {
        console.error("Invalid parsed date values:", startTimeStr, endTimeStr);
        return [];
      }

      const totalMinutes = differenceInMinutes(endTime, startTime);
      const cleaningMinutes = differenceInMinutes(wrappingTime, cleaningTime);
      const wrappingMinutes = differenceInMinutes(sterilizeTime, wrappingTime);
      const sterilizeMinutes = differenceInMinutes(endTime, sterilizeTime);

      const cleaning = Math.round(totalMinutes * 0.65);
      const wrapping = Math.round(totalMinutes * 0.2);
      const sterilizing = totalMinutes - (cleaning + wrapping);

      return [
        {
          id: 1,
          title: "Receiving Time",
          time: format(receiveTime, DATE_FORMAT),
          duration: null,
        },
        {
          id: 2,
          title: "Cleaning Time",
          // time: format(addMinutes(startTime, cleaning), DATE_FORMAT),
          time: format(cleaningTime, DATE_FORMAT),
          duration: `${cleaningMinutes} Min`,
        },
        {
          id: 3,
          title: "Wrapping Time",
          // time: format(addMinutes(startTime, cleaning + wrapping), DATE_FORMAT),
          time: format(wrappingTime, DATE_FORMAT),
          duration: `${wrappingMinutes} Min`,
        },
        {
          id: 4,
          title: "Sterilizing Time",
          time: format(sterilizeTime, DATE_FORMAT),
          duration: `${sterilizeMinutes} Min`,
        },
      ];
    } catch (error) {
      console.error("Timeline generation failed:", error);
      return [];
    }
  };

  const timelineItems =
    selectedKit !== null
      ? generateTimeline(
        selectedKit?.["Start Time"],
        selectedKit?.["End Time"],
        selectedKit?.["Receiving Time"],
        selectedKit?.["Cleaning Time"],
        selectedKit?.["Wrapping Time"],
        selectedKit?.["Sterilization Time"]
      )
      : generateTimeline(
        dataResult[0]?.["Start Time"],
        dataResult[0]?.["End Time"],
        dataResult[0]?.["Receiving Time"],
        dataResult[0]?.["Cleaning Time"],
        dataResult[0]?.["Wrapping Time"],
        dataResult[0]?.["Sterilization Time"]
      );

  console.log("timelineItems", timelineItems);

  useMemo(() => {
    populateTable();
  }, [listingObject?.kitId, listingObject?.fromDate, listingObject?.toDate]);

  return (
    <div>
      <div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4  gap-2">
          <div className="w-full md:w-3/3 lg:w-full ">
            <DropdownField
              control={control}
              name="kit"
              placeholder="Kit Name"
              dataArray={[]}
              isClearable={true}
            // searchIcon={true}
            />
          </div>

          <div className="grid grid-cols-2 items-center gap-x-2">
            <DatePickerField
              name="fromdate"
              label="From Date"
              control={control}
              inputFormat="dd-MM-yyyy"
              // error={errors.requestedDate}
              slotProps={{ textField: { size: "small" } }}
            />
            <DatePickerField
              name="toDate"
              label="To Date"
              control={control}
              inputFormat="dd-MM-yyyy"
              // error={errors.requestedDate}
              slotProps={{ textField: { size: "small" } }}
            />
          </div>
          <div className="flex justify-between lg:col-span-2 ">
            <div className="flex flex-wrap  gap-2">
              <CommonButton
                searchIcon={true}
                type={"button"}
                className={"px-4 rounded-md bg-customBlue text-white"}
                onClick={() => {
                  setListingObject((listingObject) => ({
                    ...listingObject,
                    fromDate: getFromDate,
                    toDate: getToDate,
                    // machineId: getMachine?.id,
                  }));
                }}
              />
              <CommonButton
                label={"Reset"}
                className=" border border-customRed text-customRed "
                type={"button"}
                onClick={() => {
                  reset();
                }}
              />
            </div>
          </div>
        </div>
        {
          <div className="flex gap-4">
            <div className={selectedKit !== null ? "w-[78%]" : "w-full"}>
              {isShowSpinner ? (
                <div className="flex justify-center my-28">
                  <LoadingSpinner />
                </div>
              ) : (
                <div>
                  {dataResult.length > 0 ? (
                    <CommonTransactionPaginationTable
                      dataResult={dataResult}
                      rowsPerPage={rowsPerPage}
                      renderInput={renderInput}
                      setPage={setPage}
                      tableClass="capitalize"
                      count={dataResult.length}
                      page={page}
                      populateTable={populateTable}
                      highlightRow={true}
                      setRowsPerPage={setRowsPerPage}
                      removeHeaders={[
                        "Receiving Time",
                        "Cleaning Time",
                        "Wrapping Time",
                        "Sterilization Time",
                        "Sr. No.",
                      ]}
                      customRowBgColor={"#FFC44B"}
                      editableColumns={["Status"]}
                      handleSelectedRow={handleSelectedRow}
                      rowBackgroundColor={rowBackgroundColor}
                    />
                  ) : (
                    <>
                      {!isShowSpinner && (
                        <p className="text-center  my-28 w-full text-gray-600">
                          No Record Found
                          <span className="animate-pulse">...</span>
                        </p>
                      )}
                    </>
                  )}
                </div>
              )}
            </div>
            <div className="w-[22%] mt-4">
              <div className="bg-customBlue text-white p-2 rounded-t-lg">
                <h2 className="font-medium">
                  {selectedKit !== null
                    ? selectedKit?.["Kit Batch No"]
                    : dataResult[0]?.["Kit Batch No"]}
                </h2>
              </div>
              <div className="bg-[#F8FBFF] p-4 rounded-b-lg border border-blue-100  overflow-y-auto">
                <div className="relative">
                  <div className="absolute left-3 top-3 h-[calc(100%-90px)] w-0.5 bg-customBlue"></div>

                  <div className="space-y-3 h-[305px]">
                    {timelineItems.map((item, index) => (
                      <div key={item.id} className="flex items-start relative">
                        <div className="flex-shrink-0 mr-3 z-10">
                          <div className="bg-customBlue text-white w-6 h-6 rounded-full flex items-center justify-center">
                            <span className="text-[10px]">{item.id}</span>
                          </div>
                        </div>
                        <div
                          className={`flex-grow p-2 rounded-lg border `}
                          style={{
                            backgroundColor:
                              index % 2 === 0 ? "#F4FDFF" : "#FCF4FF",
                            borderColor:
                              index % 2 === 0 ? "#90DAEA" : "#DAA6EF",
                          }}
                        >
                          <div className="flex justify-between">
                            <div>
                              <p
                                className={`font-medium text-xs text-customBlue`}
                              >
                                {item?.title}
                              </p>
                              <p className="text-gray-600 text-xs">
                                {item?.time}
                              </p>
                            </div>
                            {item.duration && (
                              <div className={`font-medium text-xs`}>
                                {item.duration}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="mt-6 flex justify-between items-center">
                  <p className="font-medium text-gray-800">
                    Total Turn Around Time :
                  </p>
                  <p className="font-medium text-green-600">
                    {selectedKit !== null
                      ? selectedKit?.["Kit Cycle Time"]
                      : dataResult[0]?.["Kit Cycle Time"]}
                  </p>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  );
}

export default CSSDKit;